
export const panelStyle = (direction, anchor, fillParent, growLastChild, alignItems, justifyContent, gap, addStyle, bg, position) => {
  const result = addStyle ? {...addStyle} : {};

  result.display = "flex";

  switch(direction) {
    case "t2b": result.flexDirection = "column"; break;
    case "b2t": result.flexDirection = "column-reverse"; break;
    case "r2l": result.flexDirection = "row-reverse"; break;
    case "l2r": case undefined: result.flexDirection = "row"; break;
    default: throw `Value error (${direction})`;
  }
  result.flexWrap = 'nowrap';

  if (anchor !== undefined) {
    switch(anchor) {
      case "tr": {
        result.position = 'absolute';
        result.top = '0px';
        result.right = '0px';
        break;
      }
      case "right": {
        result.position = 'absolute';
        result.right = '0px';
        result.top = '0px';
        result.bottom = '0px';
        break;
      }
      case "br": {
        result.position = 'absolute';
        result.bottom = '0px';
        result.right = '0px';
        break;
      }
      case "bottom": {
        result.position = 'absolute';
        result.bottom = '0px';
        result.left = '0px';
        result.right = '0px';
        break;
      }
      case "bl": {
        result.position = 'absolute';
        result.bottom = '0px';
        result.left = '0px';
        break;
      }
      case "left": {
        result.position = 'absolute';
        result.left = '0px';
        result.top = '0px';
        result.bottom = '0px';
        break;
      }
      case "tl": {
        result.position = 'absolute';
        result.top = '0px';
        result.left = '0px';
        break;
      }
      case "top": {
        result.position = 'absolute';
        result.top = '0px';
        result.left = '0px';
        result.right = '0px';
        break;
      }
      default: throw `Value error (${anchor})`;
    }
  }

  if (alignItems !== undefined) {
    let value = null;
    if (direction === undefined || direction === "t2b") {
      switch(alignItems) {
        case 'left': value = 'flex-start'; break;
        case 'center': value = 'center'; break;
        case 'right': value = 'flex-end'; break;
        case 'stretch': value = 'stretch'; break;
        case 'baseline': value = 'baseline'; break;
        default: throw `Value error (${alignItems})`;
      }
    } else if (direction === "b2t") {
      switch(alignItems) {
        case 'left': value = 'flex-end'; break;
        case 'center': value = 'center'; break;
        case 'right': value = 'flex-start'; break;
        case 'stretch': value = 'stretch'; break;
        case 'baseline': value = 'baseline'; break;
        default: throw `Value error (${alignItems})`;
      }
    } else if (direction === "l2r") {
      switch(alignItems) {
        case 'top': value = 'flex-start'; break;
        case 'center': value = 'center'; break;
        case 'bottom': value = 'flex-end'; break;
        case 'stretch': value = 'stretch'; break;
        case 'baseline': value = 'baseline'; break;
        default: throw `Value error (${alignItems})`;
      }
    } else if (direction === "r2l") {
      switch(alignItems) {
        case 'top': value = 'flex-end'; break;
        case 'center': value = 'center'; break;
        case 'bottom': value = 'flex-start'; break;
        case 'stretch': value = 'stretch'; break;
        case 'baseline': value = 'baseline'; break;
        default: throw `Value error (${alignItems})`;
      }
    }
    if (value) {
      result.alignItems = value;
    }
  }

  if (justifyContent) {
    result.justifyContent = justifyContent;
  }

  if (fillParent) {
    result.position = 'absolute';
    result.inset = '0px';
  }

  // if (growLastChild) {
  //   result.position = 'absolute';
  //   result.inset = '0px';
  // }

  if (gap) {
    result.gap = gap;
  }

  if (bg) {
    result.background = bg;
  }

  if (position !== undefined) {
    result.position = position;
  }

  return result;
}
